module.exports = __webpack_public_path__ + "img/compare-content.a3cf670b.png";